import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GoalsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;
	@service('model-manager/scripts') declare mmScriptsService: Service.ModelManager.Scripts;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/groups') declare mmGroupsService: Service.ModelManager.Groups;

	override beforeModel() {
		// need to load initial promises before we can show metric selector
		const promises = [
			this.navigationService.initialRequestsPromise,
			this.mmGoalsService.requestSpaceGoals(),
			this.mmMetricsService.requestMetrics(),
			this.mmGroupsService.requestGroups(),
			// need to request scripts and customqueries or we won't see options to edit
			this.mmCustomQueriesService.requestCustomQueries(),
			this.mmScriptsService.requestScripts(),
		];

		void this.mmGoalsService.requestSpaceGoalsData();

		return Promise.all(promises);
	}
}
